import { render, staticRenderFns } from "./ShowGoodsDetail.vue?vue&type=template&id=4285230c&scoped=true&"
import script from "./ShowGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./ShowGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShowGoodsDetail.vue?vue&type=style&index=0&id=4285230c&scoped=true&lang=css&"
import style1 from "./ShowGoodsDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285230c",
  null
  
)

export default component.exports